import logo from './ACRDM_logo.png';
import { useState, useEffect, useRef } from "react";

const T = {
  red:"#E8302A",redDark:"#C02020",redLight:"rgba(232,48,42,0.1)",
  dark:"#0A0A0A",dark2:"#111111",card:"#1A1A1A",
  text:"#F5F5F5",text2:"#9A9A9A",text3:"#555555",
  border:"rgba(255,255,255,0.06)",border2:"rgba(232,48,42,0.2)",
};

const lang = {
  en:{
    badge:"Best IT Solutions · Tamil Nadu",
    heroSub:"ACRDM Multi Tech Private Limited delivers end-to-end technology solutions — from custom application development to business automation — empowering companies across Tamil Nadu.",
    heroCta:"Get Free Consultation →",heroWork:"▶ View Our Work",
    navServices:"Services",navCases:"Case Studies",navAbout:"About",navContact:"Contact Us",
    secServicesLabel:"What We Do",secServicesTitle:"Services Built to Scale",
    secServicesSub:"From concept to deployment — technology that creates real business value.",
    secCasesLabel:"Case Studies",secCasesTitle:"Transformations We've Powered",
    secAboutLabel:"About ACRDM MultiTech Private Limited",secAboutTitle:"10+ Years of IT Excellence\nfrom Tamil Nadu",
    secContactLabel:"Get In Touch",secContactTitle:"Let's Build Something Great",
    secContactSub:"Tell us about your project. We respond within 24 hours.",
    sendBtn:"Send Message →",successMsg:"✅ Thank you! We'll contact you within 24 hours.",
    footerTagline:"End-to-end software services from Virudhunagar — powering businesses to navigate their next.",
    allRights:"All rights reserved.",
    typeWords:["Software","Applications","Automation","Solutions","Websites"],
  },
  ta:{
    badge:"சிறந்த IT தீர்வுகள் · தமிழ்நாடு",
    heroSub:"ACRDM Multi Tech Private Limited — custom software, business automation, digital marketing மூலம் உங்கள் business-ஐ அடுத்த நிலைக்கு கொண்டு செல்கிறோம்.",
    heroCta:"இலவச ஆலோசனை பெறுங்க →",heroWork:"▶ எங்கள் பணிகள்",
    navServices:"சேவைகள்",navCases:"வெற்றிகள்",navAbout:"நன்னறிமுகம்",navContact:"தொடர்பு",
    secServicesLabel:"நாங்கள் செய்வது",secServicesTitle:"வளர்ச்சிக்கான சேவைகள்",
    secServicesSub:"கருத்திலிருந்து deploy வரை — உண்மையான business மதிப்பை உருவாக்கும் தொழில்நுட்பம்.",
    secCasesLabel:"வெற்றிக் கதைகள்",secCasesTitle:"நாங்கள் மாற்றிய வாழ்க்கைகள்",
    secAboutLabel:"ACRDM பற்றி",secAboutTitle:"தமிழ்நாட்டிலிருந்து\n10+ வருட IT சிறப்பு",
    secContactLabel:"தொடர்பு கொள்ளுங்கள்",secContactTitle:"சிறந்ததை உருவாக்குவோம்",
    secContactSub:"உங்கள் திட்டம் பற்றி சொல்லுங்கள். 24 மணி நேரத்தில் பதிலளிப்போம்.",
    sendBtn:"செய்தி அனுப்புங்கள் →",successMsg:"✅ நன்றி! 24 மணி நேரத்தில் தொடர்பு கொள்வோம்.",
    footerTagline:"விருதுநகர், தமிழ்நாட்டிலிருந்து முழுமையான software சேவைகள்.",
    allRights:"அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.",
    typeWords:["மென்பொருள்","செயலிகள்","தானியங்கி","தீர்வுகள்","வலைதளங்கள்"],
  },
};

const services = [
  {icon:"🖥️",en:"Application Development",ta:"மென்பொருள் உருவாக்கம்",de:"Custom web & mobile apps — React, Node.js, Flutter.",dt:"React, Node.js-ல் custom apps."},
  {icon:"🤖",en:"Business Automation",ta:"வியாபார தானியங்கி",de:"Intelligent workflows that save time and cut costs.",dt:"நேரம் மிச்சப்படுத்தும் smart automation."},
  {icon:"📈",en:"Digital Marketing",ta:"டிஜிட்டல் மார்க்கெட்டிங்",de:"SEO, paid ads, social media that converts.",dt:"SEO, paid ads மூலம் brand வளர்ப்பு."},
  {icon:"🎬",en:"Animation & Motion",ta:"அனிமேஷன் & வீடியோ",de:"2D/3D animations that bring your brand to life.",dt:"2D/3D animation மூலம் brand story."},
  {icon:"🔒",en:"Data Security",ta:"தரவு பாதுகாப்பு",de:"Enterprise cybersecurity, audits & compliance.",dt:"Cyber attacks-இல் இருந்து பாதுகாப்பு."},
  {icon:"🔗",en:"System Integration",ta:"அமைப்பு இணைப்பு",de:"Connect ERP, CRM & APIs seamlessly.",dt:"ERP, CRM systems seamlessly இணைப்பு."},
  {icon:"🎨",en:"Experience Design",ta:"UX/UI வடிவமைப்பு",de:"Beautiful, intuitive UI/UX interfaces.",dt:"அழகான UI/UX design உருவாக்கம்."},
  {icon:"⚙️",en:"App Maintenance",ta:"தொடர் பராமரிப்பு",de:"Post-launch support, bug fixes & monitoring.",dt:"Launch-க்கு பின் continuous support."},
  {icon:"💡",en:"IT Consulting",ta:"IT ஆலோசனை",de:"Tech roadmapping & digital transformation.",dt:"Technology roadmap & transformation."},
];

const stats=[
  {num:10,suf:"+",en:"Years Experience",ta:"வருட அனுபவம்"},
  {num:200,suf:"+",en:"Projects Delivered",ta:"திட்டங்கள் நிறைவு"},
  {num:100,suf:"%",en:"Client Satisfaction",ta:"வாடிக்கையாளர் திருப்தி"},
  {num:50,suf:"+",en:"Team Members",ta:"குழு உறுப்பினர்கள்"},
];

const cases=[
  {icon:"🏭",te:"Automation",tt:"தானியங்கி",tien:"80% Reduction in Manual Work for a Virudhunagar Manufacturer",tita:"விருதுநகர் உற்பத்தியாளருக்கு 80% கைமுறை பணி குறைப்பு",de:"Custom ERP cut processing from 4 hours to 25 minutes.",dt:"Custom ERP மூலம் 4 மணி நேர பணி 25 நிமிடத்தில்.",big:true},
  {icon:"🛍️",te:"E-Commerce",tt:"இணையவழி வணிகம்",tien:"₹50L Revenue in 6 Months",tita:"6 மாதத்தில் ₹50 லட்சம்",de:"E-commerce platform + digital marketing.",dt:"E-commerce + digital marketing வளர்ச்சி."},
  {icon:"🏥",te:"Healthcare",tt:"சுகாதாரம்",tien:"Hospital Management System",tita:"மருத்துவமனை மேலாண்மை",de:"3-branch clinic unified on one platform.",dt:"3 கிளைகளை ஒரே platform-ல்."},
  {icon:"📱",te:"Mobile App",tt:"மொபைல் செயலி",tien:"Logistics App — 500+ Daily Users",tita:"Logistics செயலி — 500+ பயனர்கள்",de:"Real-time fleet tracking solution.",dt:"Real-time fleet tracking."},
  {icon:"🎓",te:"EdTech",tt:"கல்வி தொழில்நுட்பம்",tien:"Online Platform for 2,000+ Students",tita:"2,000+ மாணவர்களுக்கான Online Platform",de:"Live classes, recordings, analytics.",dt:"Live class, recorded videos, analytics."},
];

const industries=[
  {icon:"🏭",en:"Manufacturing",ta:"உற்பத்தி"},{icon:"🏥",en:"Healthcare",ta:"சுகாதாரம்"},
  {icon:"🛒",en:"Retail",ta:"சில்லறை வணிகம்"},{icon:"🎓",en:"Education",ta:"கல்வி"},
  {icon:"🏦",en:"Finance",ta:"நிதி"},{icon:"🚚",en:"Logistics",ta:"வளாட்டு"},
  {icon:"🏗️",en:"Real Estate",ta:"ரியல் எஸ்டேட்"},{icon:"🌾",en:"Agriculture",ta:"விவசாயம்"},
  {icon:"🚀",en:"Startups",ta:"தொடக்க நிறுவனங்கள்"},{icon:"🏛️",en:"Government",ta:"அரசு"},
  {icon:"🍽️",en:"F&B",ta:"உணவு"},{icon:"🎬",en:"Media",ta:"ஊடகம்"},
];

// ── HOOKS ──────────────────────────────────────────────
function useReveal(thresh=0.12){
  const ref=useRef(null);const[v,setV]=useState(false);
  useEffect(()=>{
    const o=new IntersectionObserver(([e])=>{if(e.isIntersecting){setV(true);o.disconnect();}},{threshold:thresh});
    if(ref.current)o.observe(ref.current);return()=>o.disconnect();
  },[]);return[ref,v];
}

function useCounter(target,trigger){
  const[val,setVal]=useState(0);
  useEffect(()=>{
    if(!trigger)return;let s=null;
    const step=ts=>{if(!s)s=ts;const p=Math.min((ts-s)/1800,1);const e=1-Math.pow(1-p,3);setVal(Math.floor(e*target));if(p<1)requestAnimationFrame(step);};
    requestAnimationFrame(step);
  },[trigger,target]);return val;
}

function useTypewriter(words,speed=90){
  const[text,setText]=useState("");
  const[wi,setWi]=useState(0);
  const[ci,setCi]=useState(0);
  const[del,setDel]=useState(false);
  useEffect(()=>{
    const w=words[wi]||"";
    const id=setTimeout(()=>{
      if(!del){
        if(ci<w.length){setText(w.slice(0,ci+1));setCi(c=>c+1);}
        else setTimeout(()=>setDel(true),1400);
      } else {
        if(ci>0){setText(w.slice(0,ci-1));setCi(c=>c-1);}
        else{setDel(false);setWi(i=>(i+1)%words.length);}
      }
    },del?45:speed);
    return()=>clearTimeout(id);
  },[text,ci,del,wi,words,speed]);
  return text;
}

// ── PARTICLE CANVAS ────────────────────────────────────
function ParticleCanvas(){
  const ref=useRef(null);
  useEffect(()=>{
    const c=ref.current;if(!c)return;
    const ctx=c.getContext("2d");
    let W,H,pts=[],mouse={x:-9999,y:-9999},raf;
    const resize=()=>{W=c.width=c.offsetWidth;H=c.height=c.offsetHeight;};
    const init=()=>{
      pts=[];
      const n=Math.floor((W*H)/7000);
      for(let i=0;i<n;i++)pts.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-.5)*.45,vy:(Math.random()-.5)*.45,r:Math.random()*1.5+.5});
    };
    const draw=()=>{
      ctx.clearRect(0,0,W,H);
      pts.forEach(p=>{
        p.x+=p.vx;p.y+=p.vy;
        if(p.x<0||p.x>W)p.vx*=-1;
        if(p.y<0||p.y>H)p.vy*=-1;
        const dx=p.x-mouse.x,dy=p.y-mouse.y,d=Math.hypot(dx,dy);
        if(d<100){p.x+=dx/d*1.5;p.y+=dy/d*1.5;}
        ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,Math.PI*2);
        ctx.fillStyle="rgba(232,48,42,0.55)";ctx.fill();
      });
      for(let i=0;i<pts.length;i++)for(let j=i+1;j<pts.length;j++){
        const dx=pts[i].x-pts[j].x,dy=pts[i].y-pts[j].y,d=Math.hypot(dx,dy);
        if(d<130){ctx.beginPath();ctx.moveTo(pts[i].x,pts[i].y);ctx.lineTo(pts[j].x,pts[j].y);ctx.strokeStyle=`rgba(232,48,42,${(1-d/130)*.18})`;ctx.lineWidth=.5;ctx.stroke();}
      }
      raf=requestAnimationFrame(draw);
    };
    const onM=e=>{const r=c.getBoundingClientRect();mouse={x:e.clientX-r.left,y:e.clientY-r.top};};
    window.addEventListener("resize",()=>{resize();init();});
    c.addEventListener("mousemove",onM);
    c.addEventListener("mouseleave",()=>{mouse={x:-9999,y:-9999};});
    resize();init();draw();
    return()=>{cancelAnimationFrame(raf);};
  },[]);
  return <canvas ref={ref} style={{position:"absolute",inset:0,width:"100%",height:"100%",opacity:.55}}/>;
}

// ── FLOATING CARDS ─────────────────────────────────────
function FloatingCards(){
  return(
    <>
      <style>{`
        @keyframes fA{0%,100%{transform:translateY(0) rotate(-2deg)}50%{transform:translateY(-14px) rotate(-2deg)}}
        @keyframes fB{0%,100%{transform:translateY(0) rotate(2deg)}50%{transform:translateY(-10px) rotate(2deg)}}
        @keyframes fC{0%,100%{transform:translateY(0) rotate(-1deg)}50%{transform:translateY(-18px) rotate(-1deg)}}
      `}</style>
      {[
        {icon:"✅",title:"Project Delivered",sub:"Hospital CRM · Just now",bg:"rgba(0,200,100,0.1)",br:"rgba(0,200,100,0.2)",pos:{right:"4%",top:"20%"},anim:"fA 3.2s ease-in-out infinite"},
        {icon:"⚡",title:"80% Faster",sub:"Business Automation",bg:"rgba(232,48,42,0.1)",br:"rgba(232,48,42,0.25)",pos:{right:"20%",top:"54%"},anim:"fB 3.8s ease-in-out infinite"},
        {icon:"🌐",title:"Live in 24hrs",sub:"acrdm.com deployed",bg:"rgba(0,150,255,0.1)",br:"rgba(0,150,255,0.2)",pos:{right:"5%",top:"73%"},anim:"fC 4.4s ease-in-out infinite"},
      ].map((card,i)=>(
        <div key={i} style={{position:"absolute",...card.pos,background:card.bg,border:`1px solid ${card.br}`,backdropFilter:"blur(12px)",borderRadius:14,padding:"14px 18px",minWidth:185,animation:card.anim,pointerEvents:"none"}}>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            <span style={{fontSize:"1.4rem"}}>{card.icon}</span>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:T.text,lineHeight:1.2}}>{card.title}</div>
              <div style={{fontSize:11,color:T.text2,marginTop:2}}>{card.sub}</div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

// ── GLOBAL STYLES ──────────────────────────────────────
function GlobalStyles(){
  return(
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Noto+Sans+Tamil:wght@400;500;600;700&display=swap');
      *{box-sizing:border-box;margin:0;padding:0}
      html{scroll-behavior:smooth}
      body{background:#0A0A0A;color:#F5F5F5;overflow-x:hidden;font-family:'Outfit',sans-serif}
      ::-webkit-scrollbar{width:4px}::-webkit-scrollbar-thumb{background:#E8302A;border-radius:3px}
      .rv{opacity:0;transform:translateY(24px);transition:opacity .65s ease,transform .65s ease}
      .rv.on{opacity:1;transform:none}
      @keyframes ticker{from{transform:translateX(0)}to{transform:translateX(-50%)}}
      @keyframes blink{0%,100%{opacity:1}50%{opacity:.3}}
      @keyframes fabPulse{0%,100%{box-shadow:0 8px 30px rgba(232,48,42,.4)}50%{box-shadow:0 8px 42px rgba(232,48,42,.7)}}
      @keyframes gradShift{0%{background-position:0% 50%}50%{background-position:100% 50%}100%{background-position:0% 50%}}
      @keyframes cursorBlink{0%,49%{opacity:1}50%,100%{opacity:0}}
      .svc-card{position:relative;overflow:hidden;transition:background .25s}
      .svc-card::before{content:'';position:absolute;top:0;left:0;width:0;height:2px;background:#E8302A;transition:width .4s}
      .svc-card:hover::before{width:100%}
      .svc-card:hover{background:#202020!important}
      .svc-arr{opacity:0;transform:translateX(-8px);transition:all .25s}
      .svc-card:hover .svc-arr{opacity:1;transform:none}
      .ind-itm:hover{background:#111111!important}
      .ind-itm:hover .ind-lbl{color:#E8302A!important}
      .case-c:hover{background:#202020!important}
      .nav-cta-btn:hover{background:#C02020!important}
      .fab-btn:hover{transform:translateY(-3px)!important}
      .cursor-blink{animation:cursorBlink 1s infinite;color:#E8302A}
      @media(max-width:900px){.nd{display:none!important}.hbg{display:block!important}}
      @media(min-width:901px){.hbg{display:none!important}}
      @media(max-width:768px){
        .ag,.cg,.fg{grid-template-columns:1fr!important}
        .csg{grid-template-columns:1fr!important}
        .fr{grid-template-columns:1fr!important}
        .fbt{flex-direction:column;text-align:center}
        .flt-c{display:none!important}
      }
    `}</style>
  );
}

// ── LANG TOGGLE ────────────────────────────────────────
function LangToggle({l,setL}){
  return(
    <div style={{position:"fixed",top:"1.1rem",right:"5%",zIndex:1001,display:"flex",background:T.card,border:`1px solid ${T.border}`,borderRadius:50,padding:3,gap:2}}>
      {["en","ta"].map(c=>(
        <button key={c} onClick={()=>setL(c)} style={{padding:"5px 14px",borderRadius:50,border:"none",background:l===c?T.red:"transparent",color:l===c?"#fff":T.text2,fontSize:"0.75rem",fontWeight:600,cursor:"pointer",fontFamily:c==="ta"?"'Noto Sans Tamil',sans-serif":"inherit",transition:"all .2s"}}>
          {c==="en"?"EN":"தமிழ்"}
        </button>
      ))}
    </div>
  );
}

// ── NAVBAR ─────────────────────────────────────────────
function Navbar({l,t,scrolled}){
  const[open,setOpen]=useState(false);
  const links=[[`#services`,t.navServices],[`#cases`,t.navCases],[`#about`,t.navAbout]];
  return(
    <nav style={{position:"fixed",top:0,left:0,right:0,zIndex:1000}}>
      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",height:70,padding:"0 5%",background:scrolled?"rgba(10,10,10,0.98)":"rgba(10,10,10,0.6)",backdropFilter:"blur(24px)",borderBottom:`1px solid ${T.border}`,transition:"background .3s"}}>
        <a href="#" style={{display:"flex",alignItems:"center",gap:10,textDecoration:"none",color:T.text,fontWeight:900,fontSize:"1.3rem",letterSpacing:"-0.03em"}}>
          <img src={logo} alt="ACRDM" style={{width:36,height:36,objectFit:"contain"}}/>
          ACRDM Multi Tech Private Limited<span style={{color:T.red}}></span>
        </a>
        <ul className="nd" style={{display:"flex",listStyle:"none",gap:0,height:70,alignItems:"stretch",margin:0,padding:0}}>
          {links.map(([h,lb])=>(
            <li key={h}><a href={h} style={{display:"flex",alignItems:"center",padding:"0 1rem",fontSize:"0.85rem",fontWeight:500,color:T.text2,textDecoration:"none",transition:"color .2s"}} onMouseEnter={e=>e.target.style.color=T.text} onMouseLeave={e=>e.target.style.color=T.text2}>{lb}</a></li>
          ))}
        </ul>
        <div style={{display:"flex",alignItems:"center",gap:8}}>
          <a href="#contact" className="nav-cta-btn" style={{background:T.red,color:"#fff",padding:"0.5rem 1.2rem",borderRadius:7,fontWeight:700,fontSize:"0.85rem",textDecoration:"none",transition:"background .2s"}}>{t.navContact}</a>
          <button className="hbg" onClick={()=>setOpen(!open)} style={{display:"none",background:"none",border:"none",color:T.text,fontSize:"1.4rem",cursor:"pointer"}} aria-label="menu">☰</button>
        </div>
      </div>
      {open&&(
        <div style={{background:T.dark2,borderBottom:`1px solid ${T.border}`,padding:"1.2rem 5%"}}>
          {[...links,["#contact",t.navContact]].map(([h,lb],i,arr)=>(
            <a key={h} href={h} onClick={()=>setOpen(false)} style={{display:"block",padding:i===arr.length-1?"0.8rem":"0.75rem 0",fontSize:"0.9rem",color:i===arr.length-1?"#fff":T.text2,background:i===arr.length-1?T.red:"transparent",borderRadius:i===arr.length-1?8:0,textAlign:i===arr.length-1?"center":"left",textDecoration:"none",borderBottom:i<arr.length-1?`1px solid ${T.border}`:"none",marginTop:i===arr.length-1?"0.75rem":0}}>{lb}</a>
          ))}
        </div>
      )}
    </nav>
  );
}

// ── HERO ───────────────────────────────────────────────
function Hero({l,t}){
  const typeText=useTypewriter(t.typeWords,85);
  const[ref,vis]=useReveal(0.05);
  const ta=l==="ta";
  const c0=useCounter(stats[0].num,vis);
  const c1=useCounter(stats[1].num,vis);
  const c2=useCounter(stats[2].num,vis);
  const c3=useCounter(stats[3].num,vis);
  return(
    <section id="hero" ref={ref} style={{minHeight:"100vh",display:"flex",alignItems:"center",position:"relative",overflow:"hidden",padding:"8rem 5% 5rem",background:T.dark}}>
      <ParticleCanvas/>
      <div style={{position:"absolute",top:"10%",left:"50%",transform:"translateX(-50%)",width:700,height:700,background:"radial-gradient(ellipse,rgba(232,48,42,0.06) 0%,transparent 65%)",pointerEvents:"none",zIndex:1}}/>
      <img src={logo} alt="" style={{position:"absolute",right:"3%",top:"50%",transform:"translateY(-50%)",width:260,opacity:0.04,pointerEvents:"none",zIndex:1}}/>
      <div className="flt-c" style={{position:"absolute",inset:0,zIndex:3,pointerEvents:"none"}}><FloatingCards/></div>
      <div style={{position:"relative",zIndex:4,maxWidth:700}}>
        <div style={{display:"inline-flex",alignItems:"center",gap:8,background:T.redLight,border:`1px solid ${T.border2}`,color:T.red,fontSize:"0.75rem",fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",padding:"0.4rem 1rem",borderRadius:50,marginBottom:"1.5rem",opacity:vis?1:0,transform:vis?"none":"translateY(20px)",transition:"all .6s ease"}}>
          <span style={{width:6,height:6,background:T.red,borderRadius:"50%",animation:"blink 1.5s infinite"}}/>{t.badge}
        </div>
        <h1 style={{fontWeight:900,lineHeight:1.05,letterSpacing:"-0.04em",marginBottom:"1.5rem",opacity:vis?1:0,transform:vis?"none":"translateY(20px)",transition:"all .6s .1s ease",fontFamily:ta?"'Noto Sans Tamil',sans-serif":"'Outfit',sans-serif"}}>
          <span style={{fontSize:"clamp(1.8rem,3.5vw,3rem)",display:"block",color:T.text2,fontWeight:300}}>{ta?"நாங்கள்":"We Build"}</span>
          <span style={{fontSize:"clamp(3rem,6.5vw,5.8rem)",display:"block",background:`linear-gradient(90deg,${T.red},#FF6B35,${T.red})`,backgroundSize:"200% auto",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text",animation:"gradShift 3s linear infinite",minHeight:"1.1em"}}>
            {typeText}<span className="cursor-blink" style={{WebkitTextFillColor:T.red}}>|</span>
          </span>
          <span style={{fontSize:"clamp(1.8rem,3.5vw,3rem)",display:"block",color:T.text}}>{ta?"உங்கள் வியாபாரத்தை மாற்றுகிறோம்":"That Transforms Business"}</span>
        </h1>
        <p style={{fontSize:"1.05rem",color:T.text2,maxWidth:520,lineHeight:1.85,marginBottom:"2.5rem",fontWeight:300,opacity:vis?1:0,transform:vis?"none":"translateY(20px)",transition:"all .6s .2s ease",fontFamily:ta?"'Noto Sans Tamil',sans-serif":"inherit"}}>{t.heroSub}</p>
        <div style={{display:"flex",gap:"1rem",flexWrap:"wrap",opacity:vis?1:0,transform:vis?"none":"translateY(20px)",transition:"all .6s .3s ease"}}>
          <a href="#contact" style={{background:T.red,color:"#fff",padding:"0.9rem 2.2rem",borderRadius:8,fontWeight:700,fontSize:"0.95rem",textDecoration:"none",display:"inline-flex",alignItems:"center",gap:8,boxShadow:"0 0 40px rgba(232,48,42,0.35)",transition:"transform .2s,box-shadow .2s"}} onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-2px)";e.currentTarget.style.boxShadow="0 8px 50px rgba(232,48,42,0.55)"}} onMouseLeave={e=>{e.currentTarget.style.transform="none";e.currentTarget.style.boxShadow="0 0 40px rgba(232,48,42,0.35)"}}>{t.heroCta}</a>
          <a href="#cases" style={{background:"transparent",color:T.text,padding:"0.9rem 2.2rem",borderRadius:8,fontWeight:600,fontSize:"0.95rem",textDecoration:"none",border:`1px solid ${T.border}`,transition:"all .2s"}} onMouseEnter={e=>{e.currentTarget.style.borderColor=T.red;e.currentTarget.style.color=T.red}} onMouseLeave={e=>{e.currentTarget.style.borderColor=T.border;e.currentTarget.style.color=T.text}}>{t.heroWork}</a>
        </div>
        <div style={{display:"flex",gap:"2.5rem",marginTop:"4rem",paddingTop:"3rem",borderTop:`1px solid ${T.border}`,flexWrap:"wrap",opacity:vis?1:0,transition:"all .6s .4s ease"}}>
          {[[c0,stats[0]],[c1,stats[1]],[c2,stats[2]],[c3,stats[3]]].map(([v,s])=>(<div key={s.en}><div style={{fontSize:"2.4rem",fontWeight:900,color:T.red,lineHeight:1,letterSpacing:"-0.03em"}}>{v}{s.suf}</div><div style={{fontSize:"0.78rem",color:T.text3,marginTop:4}}>{ta?s.ta:s.en}</div></div>))}
        </div>
      </div>
    </section>
  );
}

// ── TICKER ─────────────────────────────────────────────
function Ticker(){
  const items=["Application Development","Business Automation","Digital Marketing","Animation & Design","Data Security","System Integration","IT Consulting","App Maintenance"];
  return(
    <div style={{background:T.red,overflow:"hidden",padding:"0.7rem 0"}}>
      <div style={{display:"flex",gap:"3rem",whiteSpace:"nowrap",animation:"ticker 25s linear infinite"}}>
        {[...items,...items].map((item,i)=>(
          <span key={i} style={{fontSize:"0.78rem",fontWeight:700,letterSpacing:"0.08em",textTransform:"uppercase",color:"rgba(255,255,255,0.85)",display:"inline-flex",alignItems:"center",gap:"1rem"}}>
            <span style={{fontSize:"0.5rem",opacity:.7}}>✦</span>{item}
          </span>
        ))}
      </div>
    </div>
  );
}

// ── SECTION HEAD ───────────────────────────────────────
function SHead({label,title,sub,center=false}){
  const[ref,vis]=useReveal();
  return(
    <div ref={ref} className={`rv ${vis?"on":""}`} style={{marginBottom:"3.5rem",textAlign:center?"center":"left"}}>
      <div style={{fontSize:"0.7rem",fontWeight:700,letterSpacing:"0.15em",textTransform:"uppercase",color:T.red,marginBottom:"0.75rem",display:"flex",alignItems:"center",gap:10,justifyContent:center?"center":"flex-start"}}>
        {!center&&<span style={{width:18,height:2,background:T.red,display:"inline-block"}}/>}{label}
      </div>
      <h2 style={{fontSize:"clamp(1.8rem,3vw,2.8rem)",fontWeight:800,lineHeight:1.15,letterSpacing:"-0.02em",marginBottom:"1rem",whiteSpace:"pre-line"}}>{title}</h2>
      {sub&&<p style={{fontSize:"0.95rem",color:T.text2,maxWidth:520,lineHeight:1.85,fontWeight:300,margin:center?"0 auto":0}}>{sub}</p>}
    </div>
  );
}

// ── SERVICES ───────────────────────────────────────────
function Services({l,t}){
  const[ref,vis]=useReveal();
  return(
    <section id="services" style={{padding:"6rem 5%",background:T.dark2}}>
      <SHead label={t.secServicesLabel} title={t.secServicesTitle} sub={t.secServicesSub}/>
      <div ref={ref} className={`rv ${vis?"on":""}`} style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(290px,1fr))",gap:1,background:T.border}}>
        {services.map(s=>(
          <div key={s.en} className="svc-card" style={{background:T.dark2,padding:"2.5rem 2rem",cursor:"default"}}>
            <span style={{fontSize:"2rem",marginBottom:"1.25rem",display:"block"}}>{s.icon}</span>
            <div style={{fontSize:"1rem",fontWeight:700,marginBottom:"0.5rem"}}>{l==="ta"?s.ta:s.en}</div>
            <p style={{fontSize:"0.85rem",color:T.text2,lineHeight:1.75,fontWeight:300}}>{l==="ta"?s.dt:s.de}</p>
            <span className="svc-arr" style={{display:"inline-flex",alignItems:"center",gap:6,color:T.red,fontSize:"0.8rem",fontWeight:600,marginTop:"1rem"}}>Learn more →</span>
          </div>
        ))}
      </div>
    </section>
  );
}

// ── STATS ──────────────────────────────────────────────
function Stats({l}){
  const[ref,vis]=useReveal();
  const s0=useCounter(stats[0].num,vis);
  const s1=useCounter(stats[1].num,vis);
  const s2=useCounter(stats[2].num,vis);
  const s3=useCounter(stats[3].num,vis);
  return(
    <section ref={ref} style={{padding:"5rem 5%",background:T.dark}}>
      <div className={`rv ${vis?"on":""}`} style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:1,background:T.border}}>
        {[[s0,stats[0]],[s1,stats[1]],[s2,stats[2]],[s3,stats[3]]].map(([v,s])=>(
          <div key={s.en} style={{background:T.dark,padding:"3rem 2rem",textAlign:"center"}}>
            <div style={{fontSize:"3.5rem",fontWeight:900,color:T.red,letterSpacing:"-0.04em",lineHeight:1}}>{v}{s.suf}</div>
            <div style={{fontSize:"0.85rem",color:T.text2,marginTop:"0.6rem"}}>{l==="ta"?s.ta:s.en}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

// ── CASES ──────────────────────────────────────────────
function Cases({l,t}){
  const[ref,vis]=useReveal();
  return(
    <section id="cases" style={{padding:"6rem 5%",background:T.dark2}}>
      <SHead label={t.secCasesLabel} title={t.secCasesTitle}/>
      <div ref={ref} className={`rv csg ${vis?"on":""}`} style={{display:"grid",gridTemplateColumns:"1.3fr 1fr 1fr",gap:1,background:T.border}}>
        {cases.map((c,i)=>(
          <div key={i} className="case-c" style={{background:T.dark2,padding:c.big?"3rem 2.5rem":"2.5rem 2rem",transition:"background .25s",gridRow:c.big?"span 2":"span 1",minHeight:c.big?400:200,display:"flex",flexDirection:"column",justifyContent:"flex-end"}}>
            <span style={{fontSize:c.big?"3.5rem":"2.5rem",marginBottom:"1.5rem",display:"block"}}>{c.icon}</span>
            <span style={{fontSize:"0.68rem",fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:T.red,marginBottom:"0.6rem",display:"block"}}>{l==="ta"?c.tt:c.te}</span>
            <div style={{fontSize:c.big?"1.3rem":"0.95rem",fontWeight:700,lineHeight:1.4,marginBottom:"0.5rem"}}>{l==="ta"?c.tita:c.tien}</div>
            <p style={{fontSize:"0.82rem",color:T.text2,lineHeight:1.6,fontWeight:300}}>{l==="ta"?c.dt:c.de}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

// ── INDUSTRIES ─────────────────────────────────────────
function Industries({l}){
  const[ref,vis]=useReveal();
  return(
    <section style={{padding:"6rem 5%",background:T.dark}}>
      <SHead label={l==="ta"?"துறைகள்":"Industries"} title={l==="ta"?"அனைத்து துறைகளிலும் சேவை":"We Serve Across Sectors"} center/>
      <div ref={ref} className={`rv ${vis?"on":""}`} style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))",gap:1,background:T.border}}>
        {industries.map(ind=>(
          <div key={ind.en} className="ind-itm" style={{background:T.dark,padding:"1.5rem 1rem",textAlign:"center",transition:"background .2s",cursor:"default"}}>
            <span style={{fontSize:"1.8rem",marginBottom:"0.6rem",display:"block"}}>{ind.icon}</span>
            <div className="ind-lbl" style={{fontSize:"0.8rem",fontWeight:600,color:T.text2,transition:"color .2s",lineHeight:1.3}}>{l==="ta"?ind.ta:ind.en}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

// ── ABOUT ──────────────────────────────────────────────
function About({l,t}){
  const[rL,vL]=useReveal();const[rR,vR]=useReveal();
  const v200=useCounter(200,vR),v50=useCounter(50,vR),v10=useCounter(10,vR),v100=useCounter(100,vR);
  const ta=l==="ta";
  const pts=ta?["புதிய தொழில்நுட்பங்களில் நிபுணத்துவம் பெற்ற உற்சாக குழு.","ஒவ்வொரு வாடிக்கையாளருக்கும் maximum value மற்றும் வளர்ச்சி.","நேர்மை, அர்ப்பணிப்பு, வெளிப்படையான தன்மை — எங்கள் மதிப்புகள்.","விருதுநகரிலிருந்து உலகம் — TN IT திறமையை உலகிற்கு."]:["Enthusiastic team deeply skilled in emerging technologies.","We maximise business value and growth for every client.","Integrity, commitment, transparency — our core values.","From Virudhunagar to the world — TN talent going global."];
  return(
    <section id="about" style={{padding:"6rem 5%",background:T.dark2}}>
      <div className="ag" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"5rem",alignItems:"center"}}>
        <div ref={rL} className={`rv ${vL?"on":""}`}>
          <div style={{fontSize:"0.7rem",fontWeight:700,letterSpacing:"0.15em",textTransform:"uppercase",color:T.red,marginBottom:"0.75rem",display:"flex",alignItems:"center",gap:10}}>
            <span style={{width:18,height:2,background:T.red,display:"inline-block"}}/>{t.secAboutLabel}
          </div>
          <h2 style={{fontSize:"clamp(1.8rem,3vw,2.8rem)",fontWeight:800,lineHeight:1.15,letterSpacing:"-0.02em",marginBottom:"1rem",whiteSpace:"pre-line"}}>{t.secAboutTitle}</h2>
          <ul style={{listStyle:"none",marginTop:"1.5rem"}}>
            {pts.map((pt,i)=>(
              <li key={i} style={{display:"flex",alignItems:"flex-start",gap:12,fontSize:"0.9rem",color:T.text2,marginBottom:"1rem",fontWeight:300,lineHeight:1.75}}>
                <span style={{color:T.red,fontWeight:700,flexShrink:0}}>→</span>{pt}
              </li>
            ))}
          </ul>
          <a href="#contact" style={{display:"inline-flex",background:T.red,color:"#fff",padding:"0.85rem 2rem",borderRadius:8,fontWeight:700,fontSize:"0.9rem",textDecoration:"none",marginTop:"2rem"}}>{ta?"பேசுங்கள் →":"Talk to Us →"}</a>
        </div>
        <div ref={rR} className={`rv ${vR?"on":""}`} style={{position:"relative"}}>
          <div style={{fontSize:"9rem",fontWeight:900,color:T.red,opacity:0.04,position:"absolute",top:"-2rem",left:"-1rem",lineHeight:1,pointerEvents:"none"}}>10</div>
          <img src={logo} alt="ACRDM" style={{width:"100%",maxWidth:260,margin:"0 auto",display:"block",opacity:.9}}/>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,background:T.border,marginTop:"2rem",border:`1px solid ${T.border}`}}>
            {[[v200,"+","Projects","திட்டங்கள்"],[v50,"+","Team","குழு"],[v10,"+","Years","வருடங்கள்"],[v100,"%","Satisfaction","திருப்தி"]].map(([v,s,en,tl])=>(
              <div key={en} style={{background:T.dark2,padding:"1.5rem",textAlign:"center"}}>
                <div style={{fontSize:"2rem",fontWeight:900,color:T.red,lineHeight:1}}>{v}{s}</div>
                <div style={{fontSize:"0.75rem",color:T.text2,marginTop:4}}>{ta?tl:en}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ── CONTACT ────────────────────────────────────────────
function Contact({l,t}){
  const[ref,vis]=useReveal();const[done,setDone]=useState(false);const ta=l==="ta";
  const ip={background:T.card,border:`1px solid ${T.border}`,borderRadius:9,color:T.text,padding:"0.78rem 1rem",fontSize:"0.88rem",outline:"none",width:"100%"};
  return(
    <section id="contact" style={{padding:"6rem 5%",background:T.dark}}>
      <SHead label={t.secContactLabel} title={t.secContactTitle} sub={t.secContactSub}/>
      <div ref={ref} className={`rv cg ${vis?"on":""}`} style={{display:"grid",gridTemplateColumns:"1fr 1.3fr",gap:"4rem",alignItems:"start"}}>
        <div style={{background:T.dark2,border:`1px solid ${T.border}`,borderRadius:12,overflow:"hidden"}}>
          <div style={{background:T.red,padding:"1.5rem 2rem"}}><h3 style={{fontWeight:800,color:"#fff"}}>ACRDM MultiTech Private Limited</h3><p style={{fontSize:"0.82rem",color:"rgba(255,255,255,0.75)",marginTop:4}}>Virudhunagar, Tamil Nadu</p></div>
          <div style={{padding:"1.5rem 2rem"}}>
            {[["📍",ta?"அலுவலகம்":"Office","79, Ramamoorthy Road,\nVirudhunagar – 626001"],["📧","Email","info@acrdm.com"],["🌐",ta?"வலைதளம்":"Website","www.acrdm.com"],["🕘",ta?"நேரம்":"Hours",ta?"திங்கள்–வெள்ளி 9AM–5PM":"Mon–Fri, 9AM – 5PM"]].map(([icon,label,val],i,arr)=>(
              <div key={label} style={{display:"flex",alignItems:"flex-start",gap:"1rem",padding:"1rem 0",borderBottom:i<arr.length-1?`1px solid ${T.border}`:"none"}}>
                <div style={{width:40,height:40,background:T.redLight,borderRadius:10,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"1.1rem",flexShrink:0}}>{icon}</div>
                <div><div style={{fontSize:"0.72rem",color:T.text3,fontWeight:600,letterSpacing:"0.05em",textTransform:"uppercase"}}>{label}</div><div style={{fontSize:"0.9rem",fontWeight:600,marginTop:2,whiteSpace:"pre-line"}}>{val}</div></div>
              </div>
            ))}
          </div>
        </div>
        <form onSubmit={e=>{e.preventDefault();setTimeout(()=>setDone(true),1000);}} style={{display:"flex",flexDirection:"column",gap:"1rem"}}>
          <div className="fr" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"1rem"}}>
            <label style={{display:"flex",flexDirection:"column",gap:6}}><span style={{fontSize:"0.75rem",color:T.text2,fontWeight:600}}>{ta?"முழு பெயர்":"Full Name"}</span><input required placeholder="Your name" style={ip}/></label>
            <label style={{display:"flex",flexDirection:"column",gap:6}}><span style={{fontSize:"0.75rem",color:T.text2,fontWeight:600}}>Email</span><input type="email" required placeholder="you@company.com" style={ip}/></label>
          </div>
          <div className="fr" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"1rem"}}>
            <label style={{display:"flex",flexDirection:"column",gap:6}}><span style={{fontSize:"0.75rem",color:T.text2,fontWeight:600}}>{ta?"தொலைபேசி":"Phone"}</span><input placeholder="+91 00000 00000" style={ip}/></label>
            <label style={{display:"flex",flexDirection:"column",gap:6}}><span style={{fontSize:"0.75rem",color:T.text2,fontWeight:600}}>{ta?"நிறுவனம்":"Company"}</span><input placeholder="Company name" style={ip}/></label>
          </div>
          <label style={{display:"flex",flexDirection:"column",gap:6}}><span style={{fontSize:"0.75rem",color:T.text2,fontWeight:600}}>{ta?"சேவை":"Service"}</span>
            <select style={ip}><option>{ta?"ஒரு சேவையைத் தேர்ந்தெடுங்கள்...":"Select a service..."}</option>{services.map(s=><option key={s.en}>{ta?s.ta:s.en}</option>)}</select>
          </label>
          <label style={{display:"flex",flexDirection:"column",gap:6}}><span style={{fontSize:"0.75rem",color:T.text2,fontWeight:600}}>{ta?"செய்தி":"Message"}</span><textarea rows={5} placeholder={ta?"உங்கள் திட்டம் பற்றி சொல்லுங்கள்...":"Describe your project..."} style={{...ip,resize:"none"}}/></label>
          {!done?<button type="submit" style={{background:T.red,color:"#fff",padding:"0.9rem",borderRadius:9,border:"none",fontWeight:700,fontSize:"0.9rem",cursor:"pointer",transition:"background .2s",boxShadow:"0 4px 20px rgba(232,48,42,0.3)"}}>{t.sendBtn}</button>:<div style={{background:"rgba(0,200,100,0.1)",border:"1px solid rgba(0,200,100,0.2)",borderRadius:9,padding:"1rem",color:"#00C864",fontWeight:600,textAlign:"center"}}>{t.successMsg}</div>}
        </form>
      </div>
    </section>
  );
}

// ── FOOTER ─────────────────────────────────────────────
function Footer({l,t}){
  const ta=l==="ta";
  return(
    <footer style={{background:"#0D0D0D",borderTop:`1px solid ${T.border}`}}>
      <div className="fg" style={{padding:"4rem 5%",display:"grid",gridTemplateColumns:"1.8fr 1fr 1fr 1fr",gap:"3rem"}}>
        <div>
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:"1rem"}}>
            <img src={logo} alt="ACRDM" style={{width:36,height:36,objectFit:"contain"}}/>
            <span style={{fontSize:"1.2rem",fontWeight:900}}>ACRDM MultiTech Private Limited<span style={{color:T.red}}></span></span>
          </div>
          <p style={{fontSize:"0.85rem",color:T.text2,lineHeight:1.75,maxWidth:240,marginBottom:"1.5rem",fontWeight:300}}>{t.footerTagline}</p>
          <div style={{display:"flex",gap:8}}>
            {["f","𝕏","in","▶"].map((s,i)=>(
              <a key={i} href="#" style={{width:34,height:34,background:T.card,border:`1px solid ${T.border}`,borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",fontSize:"0.8rem",color:T.text2,textDecoration:"none",transition:"all .2s"}} onMouseEnter={e=>{e.currentTarget.style.background=T.red;e.currentTarget.style.color="#fff";}} onMouseLeave={e=>{e.currentTarget.style.background=T.card;e.currentTarget.style.color=T.text2;}}>{s}</a>
            ))}
          </div>
        </div>
        <div><h4 style={{fontSize:"0.7rem",fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:T.text2,marginBottom:"1.2rem"}}>{ta?"சேவைகள்":"Services"}</h4><ul style={{listStyle:"none"}}>{services.slice(0,5).map(s=><li key={s.en} style={{marginBottom:"0.65rem"}}><a href="#services" style={{fontSize:"0.85rem",color:T.text3,textDecoration:"none"}} onMouseEnter={e=>e.target.style.color=T.text} onMouseLeave={e=>e.target.style.color=T.text3}>{ta?s.ta:s.en}</a></li>)}</ul></div>
        <div><h4 style={{fontSize:"0.7rem",fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:T.text2,marginBottom:"1.2rem"}}>{ta?"நிறுவனம்":"Company"}</h4><ul style={{listStyle:"none"}}>{[["#services",ta?"சேவைகள்":"Services"],["#cases",ta?"வெற்றிகள்":"Case Studies"],["#about",ta?"நன்னறிமுகம்":"About"],["#contact",ta?"தொடர்பு":"Contact"]].map(([h,lb])=><li key={h} style={{marginBottom:"0.65rem"}}><a href={h} style={{fontSize:"0.85rem",color:T.text3,textDecoration:"none"}} onMouseEnter={e=>e.target.style.color=T.text} onMouseLeave={e=>e.target.style.color=T.text3}>{lb}</a></li>)}</ul></div>
        <div><h4 style={{fontSize:"0.7rem",fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:T.text2,marginBottom:"1.2rem"}}>Legal</h4><ul style={{listStyle:"none"}}>{[["Privacy Policy","தனியுரிமை"],["Terms of Use","விதிமுறைகள்"],["Cookie Policy","Cookie"]].map(([en,tl])=><li key={en} style={{marginBottom:"0.65rem"}}><a href="#" style={{fontSize:"0.85rem",color:T.text3,textDecoration:"none"}}>{ta?tl:en}</a></li>)}</ul></div>
      </div>
      <div className="fbt" style={{padding:"1.4rem 5%",borderTop:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:"1rem"}}>
        <div style={{fontSize:"0.8rem",color:T.text3}}>© 2026 ACRDM MultiTech Private Limited. {t.allRights}</div>
        <div style={{display:"flex",gap:"1.5rem"}}>{["Privacy","Terms","Sitemap"].map(s=><a key={s} href="#" style={{fontSize:"0.8rem",color:T.text3,textDecoration:"none"}}>{s}</a>)}</div>
      </div>
    </footer>
  );
}

// ── APP ────────────────────────────────────────────────
export default function App(){
  const[l,setL]=useState("en");
  const[scrolled,setScrolled]=useState(false);
  useEffect(()=>{const h=()=>setScrolled(window.scrollY>60);window.addEventListener("scroll",h);return()=>window.removeEventListener("scroll",h);},[]);
  const t=lang[l];
  return(
    <div style={{fontFamily:l==="ta"?"'Noto Sans Tamil','Outfit',sans-serif":"'Outfit',sans-serif"}}>
      <GlobalStyles/>
      <LangToggle l={l} setL={setL}/>
      <Navbar l={l} t={t} scrolled={scrolled}/>
      <button className="fab-btn" onClick={()=>alert("Contact: info@acrdm.com")} style={{position:"fixed",bottom:"2rem",right:"2rem",zIndex:998,background:T.red,color:"#fff",border:"none",borderRadius:16,padding:"0.8rem 1.3rem",fontWeight:700,fontSize:"0.85rem",display:"flex",alignItems:"center",gap:8,cursor:"pointer",animation:"fabPulse 3s ease infinite",transition:"transform .2s"}}>
        <span style={{width:7,height:7,background:"#fff",borderRadius:"50%",animation:"blink 1.5s infinite"}}/>{l==="ta"?"AI கேளுங்க":"Ask AI"}
      </button>
      <Hero l={l} t={t}/>
      <Ticker/>
      <Services l={l} t={t}/>
      <Stats l={l}/>
      <Cases l={l} t={t}/>
      <Industries l={l}/>
      <About l={l} t={t}/>
      <Contact l={l} t={t}/>
      <Footer l={l} t={t}/>
    </div>
  );
}
